import styled from "../../theme/styled-components";
import { defaultButtonCss } from "./Button";

export const LoadMoreButton = styled.button`
  ${defaultButtonCss};
  font-size: 1.2rem;
  min-width: 100px;
  margin-top: 2rem;
`;
